import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class CertificateGenerationParameters {

  @jsonMember({name: 'validity'})
  public Validity!: number;

  @jsonArrayMember(String, {name: 'dnss'})
  public Dnss!: string[];

  @jsonMember({name: 'keyLength'})
  public KeyLength!: number;

  @jsonMember({name: 'passphrase'})
  public Passphrase!: string;

  constructor(init?: CertificateGenerationParameters) {
    if (init) {
      this.Validity = init.Validity;
      this.Dnss = init.Dnss;
      this.KeyLength = init.KeyLength;
      this.Passphrase = init.Passphrase;
    }
  }
}
